<template>
	<div>
		<div class="d21-profile__content d21-profile__reservations">
			<Loader v-if="!isLoaded" />
			<template v-if="groups.length > 0">
				<template v-for="group in groups">
					<div class="mdl-grid reservation-items" :key="group.Status">
						<h4>{{ getStatus(group.Status) }}</h4>
						<div class="mdl-grid-row mdl-m--hidden">
							<div class="mdl-cell mdl-cell--2-col mdl-cell--5-col-m">
								<label>{{ T("ticketing_valid") }}</label>
							</div>
							<div class="mdl-cell mdl-cell--3-col mdl-cell--5-col-m">
								<label>{{ T("ticketing_ticket") }}</label>
							</div>
							<div class="mdl-cell mdl-cell--3-col mdl-cell--5-col-m">
								<label>{{ T("ticketing_code") }}</label>
							</div>
							<div class="mdl-cell mdl-cell--2-col mdl-cell--2-col-m">
								<label>{{ T("ticketing_price") }}</label>
							</div>
							<div class="mdl-cell mdl-cell--2-col mdl-cell--2-col-m">
								<label>&nbsp;</label>
							</div>
						</div>
						<div class="mdl-grid-row" v-for="item in group.Items" :key="item._uuid">
							<div class="mdl-cell mdl-cell--2-col mdl-cell--6-col-m">
								<label class="mdl-m--shown">{{ T("ticketing_valid") }}</label>
								<span class="date">{{ getDate(item.From.Date) }}</span>
								<span class="time">{{ getTime(item) }}</span>
							</div>
							<div class="mdl-cell mdl-cell--3-col mdl-cell--6-col-m">
								<label class="mdl-m--shown">{{ T("ticketing_ticket") }}</label>
								<span class="venue">{{ item.Venue }}</span>
								<span class="product">{{ getProducts(item) }}</span>
							</div>
							<div class="mdl-cell mdl-cell--3-col mdl-cell--6-col-m">
								<label class="mdl-m--shown">{{ T("ticketing_code") }}</label>
								<span class="code">{{ item.Code }}</span>
							</div>
							<div class="mdl-cell mdl-cell--2-col mdl-cell--6-col-m">
								<label class="mdl-m--shown">{{ T("ticketing_price") }}</label>
								<span class="price">{{ getPrice(item.Total) }}</span>
							</div>
							<div class="mdl-cell mdl-cell--2-col mdl-cell--6-col-m">
								<label class="mdl-m--shown">&nbsp;</label>
								<button class="btn btn-black" @click="showModal(item)">{{ T("ticketing_scan") }}</button>
							</div>
						</div>
					</div>
				</template>
			</template>
			<div v-else-if="isLoaded">
				{{ T("ticketing_no_bookings") }}
			</div>
		</div>

		<Modal name="profile.qr-code" :title="T('reservation')" :actions="qrCodeModalActions">
			<div v-if="item">
				<div class="mdl-grid d-flex center">
					<label>{{ item.Code }}</label>
				</div>
				<QrCode :value="item.Code" class="mt-4" size="250" />
				<div class="mt-4 mdl-grid flex-col">
					<div class="date">
						{{ getDate(item.From.Date) }}
					</div>
					<div class="time">
						{{ getTime(item) }}
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import moment from "moment";
	import baseMixin from "../mixins/base";
	import Loader from "./ui/loader.vue";
	import {
		EventBus
	} from "../scripts/_eventBus.js";
	import QrCode from "qrcode.vue";
	import Modal from './modal.vue';

	export default {
		mixins: [baseMixin],
		name: "d21-profile-reservations",
		components: {
			Loader,
			QrCode,
			Modal
		},
		data() {
			return {
				groups: [],
				isLoaded: false,
				item: null,
				showQRCode: false
			};
		},
		mounted() {
			this.loadReservations();
		},
		computed: {
			qrCodeModalActions() {
				return [{
					text: this.T('close'),
					onClick: () => {
						this.$modals.hide('profile.qr-code');
					},
					isPrimary: true
				}];
			}
		},
		methods: {
			loadReservations() {
				EventBus.$emit("loading_start");
				const tokenParameter = encodeURIComponent(this.Profile.Token);
				this.apiRequest(`/profile/${this.$route.params.channel}/reservations?token=${tokenParameter}`, null, "GET", result => {
					if (result.Meta.IsValid) {
						this.groups = result.Value;
						this.isLoaded = true;
					} else {
						this.groups = [];
					}
					EventBus.$emit("loading_end");
				}, error => {
					EventBus.$emit("loading_end");
				});
			},
			toHome() {
				this.$router.push(`/${this.$route.params.channel}/profile/home`);
			},
			getDate(date) {
				return moment(date).format("ddd, DD.MM.YYYY");
			},
			getTime(item) {
				return `${moment(item.Products[0].Period.From).format("HH:mm")}-${moment(item.Products[0].Period.Until).format("HH:mm")} Uhr`;
			},
			getProducts(item) {
				let str = "";
				item
					.Products
					.forEach(product => {
						if (str !== "") str += ", ";
						str += `${product.Selling.Count}x ${product.Name}`;
					});
				return str;
			},
			getPrice(price) {
				return price.toFixed(2) + " EUR";
			},
			getStatus(status) {
				switch (status) {
					case "InPast":
						return "Abgelaufene Buchungen";
					default:
						return "Aktive Buchungen";
				}
			},
			showModal(item) {
				this.item = item;
				this.$modals.show("profile.qr-code");
			},
			hideModal() {
				this.item = null;
				this.$modals.hide("profile.qr-code");
			}
		}
	}
</script>

<style lang="less">
	.date,
	.venue,
	.product,
	.time,
	.code,
	.price {
		display: block;
	}

	.date {
		text-transform: uppercase;
		font-size: .8em;
	}

	.venue,
	.product,
	.price,
	.time,
	.code {
		font-size: .9em;
	}

	.time {
		color: #999;
	}

	.reservation-items {

		.mdl-grid-row:not(:first-child):not(:last-child) {
			border-bottom: 1px solid rgba(0, 0, 0, .05);
		}
	}
</style>